module.exports = __webpack_public_path__ + "static/one-partner-one-solution-9833edc80fa1f81dc70058dd0c487b58.svg";